import { useCallback, useState } from 'react';
import type { TextLayoutEvent } from 'react-native';

import { isTextClipped } from '@/utils/is-text-clipped';

/**
 * Detects whether single-line text is clipping within its container.
 *
 * Pair the returned `onTextLayout` with an invisible, width-constrained measuring `<Text>` that has
 * NO `numberOfLines` cap (a copy of the visible, clamped text). When that copy wraps to more than one
 * line, the visible single-line text must be overflowing — so callers can reveal a fade/shadow only then.
 */
export const useIsTextClipped = () => {
    const [isClipped, setIsClipped] = useState(false);

    const onTextLayout = useCallback((e: TextLayoutEvent) => {
        setIsClipped(isTextClipped(e));
    }, []);

    return { isClipped, onTextLayout };
};
